import { Component, AfterViewInit, DoCheck, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { OwnerCarrierService } from '../../../service/owner-carrier/owner-carrier.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { TypePrintDeliService } from '../../../service/type-print-deli/type-print-deli.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9232',
  templateUrl: 'wa9232.component.html',
  styleUrls: ['wa9232.component.scss']
})

export class Wa9232Component implements AfterViewInit, DoCheck, OnChanges {
  public componentTitle = 'WA9232:荷主別配送会社マスタ登録';

  // selected owner info
  public ownerResult: any;

  // 固有入力対象配送会社コード
  public custCdInputForCarrierCd = null;

  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // drop down list
  public owners: any
  public carriers: any
  public typeprintdelis: any
  public selectedOwnerId;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId = new FormControl('', [
    Validators.required,
  ]);
  public carrierCd = new FormControl('', [
    Validators.required,
  ]);
  public typeprintdeliCd = new FormControl('', [
    Validators.required,
  ]);
  public yamatocusthCd = new FormControl('', [
    Validators.pattern(validation.yamatocusthCd.pattern),
  ]);
  public yamatocustdCd = new FormControl('', [
    Validators.pattern(validation.yamatocustdCd.pattern),
  ]);
  public sagawacusthCd = new FormControl('', [
    Validators.pattern(validation.sagawacusthCd.pattern),
  ]);
  public sagawacustdCd = new FormControl('', [
    Validators.pattern(validation.sagawacustdCd.pattern),
  ]);
  public sagawacustcheckCd = new FormControl('', [
    Validators.pattern(validation.sagawacustcheckCd.pattern),
  ]);
  public jpcustCd = new FormControl('', [
    Validators.pattern(validation.jpcustCd.pattern),
  ]);
  public seinocustCd = new FormControl('', [
    Validators.pattern(validation.seinocustCd.pattern),
  ]);
  public fukuyamacusthCd = new FormControl('', [
    Validators.pattern(validation.fukuyamacusthCd.pattern),
  ]);
  public fukuyamacustdCd = new FormControl('', [
    Validators.pattern(validation.fukuyamacustdCd.pattern),
  ]);
  public recShipcaseFl = 0;

  // build FormGroup
  myForm = this.builder.group({
    ownerId: this.ownerId,
    carrierCd: this.carrierCd,
    typeprintdeliCd: this.typeprintdeliCd,
    yamatocusthCd: this.yamatocusthCd,
    yamatocustdCd: this.yamatocustdCd,
    sagawacusthCd: this.sagawacusthCd,
    sagawacustdCd: this.sagawacustdCd,
    sagawacustcheckCd: this.sagawacustcheckCd,
    jpcustCd: this.jpcustCd,
    seinocustCd: this.seinocustCd,
    fukuyamacusthCd: this.fukuyamacusthCd,
    fukuyamacustdCd: this.fukuyamacustdCd,
  });

  private openwindow: boolean = false;
  private errorInfo = '';
  @Output() onSubmitClick = new EventEmitter();
  @Input() selectedownerId;

  private ownerIdCls = '';
  private isDelayHide = true;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerCarrierService: OwnerCarrierService,
    private ownerService: OwnerService,
    private carrierService: CarrierService,
    private typePrintDeliService: TypePrintDeliService,
    private commonService: CommonService,
  ) {
    sessionStorage.removeItem('wa9232openotherwindow');
    this.checkNeedCustCd();
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  ngOnChanges() {
    this.ownerService
      .get()
      .then(outputJson => {
        if (this.selectedownerId) {
          this.owners = outputJson.owners.filter((item, index) => {
            if (item.ownerId === this.selectedownerId) return true;
          });
          this.ownerId.setValue(this.selectedownerId);
        } else {
          this.owners = outputJson.owners;
          this.ownerId.setValue('');
        }
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {

        try {
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
          if (JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {

            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === JSON.parse(sessionStorage.getItem('ownerResult')).ownerId) return true;
            });
            this.selectedownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
            this.ownerId.setValue(JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx);
            this.ownerResult = sessionStorage.getItem('ownerResult');

          } else {
            this.owners = outputJson.owners;
            this.selectedownerId = null;
            this.ownerResult = sessionStorage.getItem('ownerResult');

            this.ownerId.setValue('');

          }
        } catch (error) {
          this.selectedownerId = null;
        }
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    this.carrierService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.carriers = __outputJson.carriers;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typePrintDeliService
      .get()
      .then(___outputJson => {
        console.log(___outputJson);
        this.typeprintdelis = ___outputJson.typeprintdelis;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onChangeCarrier(event) {
    this.errorInfo = '';

    this.checkNeedCustCd();
  }

  onChangeTypePrintDeli(event) {
    this.errorInfo = '';

    this.checkNeedCustCd();
  }

  checkNeedCustCd() {
    if (this.typeprintdeliCd.value === '40') {
      this.custCdInputForCarrierCd = this.carrierCd.value;
    } else {
      this.custCdInputForCarrierCd = null;
    }
  }

  onSubmit() {
    let errors = false;
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.carrierCd.errors !== null) {
      this.carrierCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeprintdeliCd.errors !== null) {
      this.typeprintdeliCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    var attrMap = {};
    if (this.custCdInputForCarrierCd === '1001') {
      var yamatocusthCd = this.yamatocusthCd.value.trim();
      var yamatocustdCd = this.yamatocustdCd.value.trim();
      if (!this.yamatocusthCd.value) {
        this.errorInfo = 'ヤマトのサーマル伝票を選択した場合は、（運賃請求先コード12桁）を入力してください';
        return;
      }
      if (!yamatocusthCd) {
        yamatocusthCd = ''
      }
      if (!yamatocustdCd) {
        yamatocustdCd = ''
      }

      attrMap = {
        'YAMATOCUSTH_CD': yamatocusthCd,
        'YAMATOCUSTD_CD': yamatocustdCd
      }
    }
    else if (this.custCdInputForCarrierCd === '1002') {
      var sagawacusthCd = this.sagawacusthCd.value.trim();
      var sagawacustdCd = this.sagawacustdCd.value.trim();
      var sagawacustcheckCd = this.sagawacustcheckCd.value.trim();
      if (!this.sagawacusthCd.value || !this.sagawacustdCd.value || !this.sagawacustcheckCd.value) {
        this.errorInfo = '佐川のサーマル伝票を選択した場合は、顧客コード（親番8桁・枝番3桁・チェックデジット1桁）を入力してください';
        return;
      }

      attrMap = {
        'SAGAWACUSTH_CD': sagawacusthCd,
        'SAGAWACUSTD_CD': sagawacustdCd,
        'SAGAWACUSTCHECK_CD': sagawacustcheckCd
      }

    }
    else if (this.custCdInputForCarrierCd === '1003') {
      var jpcustCd = this.jpcustCd.value.trim();
      if (!this.jpcustCd.value) {
        this.errorInfo = 'JPのサーマル伝票を選択した場合は、（ゆうびんビズカードお客さま番号32桁）を入力してください';
        return;
      }

      attrMap = {
        'JPCUST_CD': jpcustCd
      }
    }
    else if (this.custCdInputForCarrierCd === '1004') {
      var seinocustCd = this.seinocustCd.value.trim();
      if (!this.seinocustCd.value) {
        this.errorInfo = '西濃のサーマル伝票を選択した場合は、（西濃・運賃契約荷主コード11桁）を入力してください';
        return;
      }

      attrMap = {
        'SEINOCUST_CD': seinocustCd
      }
    }
    else if (this.custCdInputForCarrierCd === '1006') {
      var fukuyamacusthCd = this.fukuyamacusthCd.value.trim();
      var fukuyamacustdCd = this.fukuyamacustdCd.value.trim();
      if (!this.fukuyamacusthCd.value || !this.fukuyamacustdCd.value) {
        this.errorInfo = '福山通運のサーマル伝票を選択した場合は、（荷主コード10桁・部課所コード枝番6桁）を入力してください';
        return;
      }

      attrMap = {
        'FUKUYAMACUSTH_CD': fukuyamacusthCd,
        'FUKUYAMACUSTD_CD': fukuyamacustdCd
      }
    }

    if (this.carrierCd.value === '1001') {
      attrMap['YAMATO_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd.value === '1002') {
      attrMap['SAGAWA_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd.value === '1003') {
      attrMap['JP_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd.value === '1004') {
      attrMap['SEINO_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd.value === '1006') {
      attrMap['FUKUYAMA_RECSHIPCASE'] = this.recShipcaseFl;
    }


    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    let ownerIdValue = this.selectedOwnerId ? this.selectedOwnerId : this.ownerId.value;
    this.ownerCarrierService
      .post(
        ownerIdValue,
        this.carrierCd.value,
        this.typeprintdeliCd.value,
        attrMap,
        'wa9232'
      )
      .then(outputJson => {
        sessionStorage.setItem('isShowOwnerSelect', 'true');
        sessionStorage.setItem('isNotifyRefresh9231', 'true');
        sessionStorage.removeItem('wa9232openotherwindow');
        this.errorInfo = '';
        this.resetDatas();
        this.cancel();
        this.onSubmitClick.emit();
        this.working2 = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working2 = false;
      });
  }

  ngDoCheck() {
    if (sessionStorage.getItem('wa9232openotherwindow') === 'open') {
      this.openwindow = true;
      this.isDelayHide = false;
    }

    if (sessionStorage.getItem('isWa9232FirstOpen') != null) {
      sessionStorage.removeItem('isWa9232FirstOpen');
      this.onView();
    }

    let errors = false;
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.carrierCd.errors !== null) {
      this.carrierCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeprintdeliCd.errors !== null) {
      this.typeprintdeliCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      this.working = false;
    } else {
      this.working = true;
    }

    this.ownerIdCls = this.selectedownerId == null || this.selectedownerId == undefined ? this.ownerId.value === '' ? '' : 'active' : this.selectedownerId === this.ownerId.value ? 'disabled' : 'active';

  }

  cancel() {
    this.resetDatas();
    sessionStorage.removeItem('wa9232openotherwindow');
    sessionStorage.setItem('isShowOwnerSelect', 'true');

    this.openwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
  }

  resetDatas() {
    this.errorInfo = '';
    this.ownerId.setValue('');
    this.carrierCd.setValue('');
    this.typeprintdeliCd.setValue('');
    this.yamatocusthCd.setValue('');
    this.yamatocustdCd.setValue('');
    this.sagawacusthCd.setValue('');
    this.sagawacustdCd.setValue('');
    this.sagawacustcheckCd.setValue('');
    this.jpcustCd.setValue('');
    this.seinocustCd.setValue('');
    this.fukuyamacusthCd.setValue('');
    this.fukuyamacustdCd.setValue('');
  }

  change(event) {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9232/wa9232.component.ts